import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import _get from 'hs-lodash/get';
import { useContext, useMemo } from 'react';
import { PropertiesContext } from '../../../../contexts/properties/context';
import { UIFormControlWrapper } from './UIInputWrapper.style';
import { jsx as _jsx } from "react/jsx-runtime";
const UIInputWrapper = ({
  children,
  property,
  editMode,
  ariaLabel,
  dataTestId
}) => {
  const {
    validationErrors,
    isValidating,
    validatingField
  } = useContext(PropertiesContext);
  const propertyValidationError = useMemo(() => _get(validationErrors[property.name], 'message', ''), [property, validationErrors]);
  const validationMessage = useMemo(() => isValidating && validatingField === property.name ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.loading.validating"
  }) : propertyValidationError, [isValidating, property, propertyValidationError, validatingField]);
  return /*#__PURE__*/_jsx(UIFormControlWrapper, {
    editMode: editMode,
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": ariaLabel,
      "data-test-id": dataTestId,
      error: editMode ? undefined : !!propertyValidationError,
      validationMessage: editMode ? undefined : validationMessage,
      children: children
    })
  });
};
export default UIInputWrapper;